import { FunctionComponent } from 'react'
import { TOITeaserAPIProps } from './types'
import ToiTeaserComponents from '@components/Teaser/Toi'

interface TeaserLogoProps {
  logo?: TOITeaserAPIProps['logo']
}

const { Logo } = ToiTeaserComponents

const TeaserLogo: FunctionComponent<TeaserLogoProps> = ({ logo }) => {
  if (!logo?.src) {
    return null
  }

  return (
    <Logo
      src={logo.src}
      alt={logo.alt}
      width={logo.width}
      height={logo.height}
      crops={logo?.crops ?? {}}
    />
  )
}

export default TeaserLogo
